module.exports = __webpack_public_path__ + "static/media/house-8.b60bfa97.jpg";